import React from "react";
import { buildTranslator, CustomForm, CustomFormAnswer, CustomFormSelection, isInputField, permissionGroupHelper, PermissionGroupId, UserToken } from "../../../amorg-common";
import { customFormsVideoSubmissionEnabled, getCustomFormAnswer, getCustomFormSelectionOverview, submitCustomFormAnswerFields } from "../../../api/customFormClientApi";
import { LoadingPageOverlay } from "../../../designSystem/LoadingPageOverlay";
import { H2, H3 } from "../../../designSystem/typography/Heading";
import { customFormFieldFactory } from "./customFormFieldFactory";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { getCookieUser } from "../../../api/serverApiHelpers";

type CustomFormAnswerSubmissionPanelProps = {
    siteId:string,
    form:CustomForm,
    answerId:string,
    disableAnswerComponents:boolean
}
export function CustomFormAnswerSubmissionPanel(props:CustomFormAnswerSubmissionPanelProps):JSX.Element
{
    const [state, setState] = React.useState<
        {
            isLoading:boolean,
            videoSubmissionEnabled:boolean,
            answer:CustomFormAnswer,
            user?:UserToken
        }>({ isLoading:true, videoSubmissionEnabled:false, answer:null });

    React.useEffect(() => {
        const getData = async () => {
            const answer = await getCustomFormAnswer(props.answerId, props.siteId);
            const videoSubmissionEnabled = await customFormsVideoSubmissionEnabled(props.siteId);
            const cookieUser = await getCookieUser();
            const user = cookieUser.status === 'valid' ? cookieUser.token : undefined;

            setState({ isLoading:false, videoSubmissionEnabled, answer, user });
        }
        getData();
    }, [props.answerId]);

    async function handleUpdate()
    {
        setState({ ...state, isLoading:true });
        const answer = await getCustomFormAnswer(props.answerId, props.siteId);
        setState({ ...state, isLoading:false, answer });
    }

    async function onSubmit(selections:CustomFormSelection[])
    {
        setState({ ...state, isLoading:true });
        await submitCustomFormAnswerFields(props.answerId, props.siteId, selections);
        setState({ ...state, isLoading:false});
    }

    const translator = buildTranslator('da');

    return (
        <>
        {props.form && state.answer &&
            <article>
                <LoadingPageOverlay loading={state.isLoading} />
                <Flex flexDirection='column' gap={32}>
                <section>
                    <H2>{translator(props.form.name)}</H2>
                    <H3>{translator(props.form.description)}</H3>
                </section>

                <section style={{display:'flex', flexDirection:'column', gap:32}}>
                    {props.form?.fields.map((field) => {
                        let show = true;
                        if(isInputField(field))
                        {
                            if(field.permissionGroupFilter)
                            {
                                let permissionGroupId:PermissionGroupId = 'anonymous'
                                if(state.user && state.user.permissionGroupId)
                                    permissionGroupId = state.user.permissionGroupId;

                                show = permissionGroupHelper.hasMinimumPermissionGroup(permissionGroupId, field.permissionGroupFilter);
                            }
                        }
                        if(show)
                        {
                            return (
                                <div key={field.fieldId}>
                                    {customFormFieldFactory.getAnswerFieldComponent(field, 
                                        {
                                            siteId:props.siteId,
                                            form:props.form,
                                            answer:state.answer,
                                            disabled:props.disableAnswerComponents,
                                            videoSubmissionEnabled:state.videoSubmissionEnabled,
                                            doUpdate:handleUpdate,
                                            onSubmit,
                                            getFieldOptions: async () => {
                                                return await getCustomFormSelectionOverview(props.siteId, props.form.id);
                                            }
                                        }
                                    )}
                                </div>
                            );
                        } 
                    })}
                </section>
                </Flex>
            </article>
        }
        </>
    );
}